const INIT_GUARD = "__themeInterneCf7ChoiceItemsInit";
const FOCUSABLE_ATTR = "data-cf7-choice-focusable";

const enhanceChoiceItems = () => {
  document
    .querySelectorAll(
      ".wpcf7-checkbox .wpcf7-list-item, .wpcf7-radio .wpcf7-list-item",
    )
    .forEach((listItem) => {
      if (listItem.getAttribute(FOCUSABLE_ATTR) === "1") return;

      const input = listItem.querySelector(
        'input[type="checkbox"], input[type="radio"]',
      );
      if (!input || input.disabled) return;

      listItem.setAttribute(FOCUSABLE_ATTR, "1");
      listItem.setAttribute("tabindex", "0");
      input.setAttribute("tabindex", "-1");
    });
};

export const initFormChoiceClickableItems = () => {
  if (typeof globalThis !== "undefined" && globalThis[INIT_GUARD]) return;
  if (typeof globalThis !== "undefined") globalThis[INIT_GUARD] = true;

  enhanceChoiceItems();

  ["wpcf7mailsent", "wpcf7reset", "wpcf7invalid"].forEach((evt) => {
    document.addEventListener(evt, () => {
      requestAnimationFrame(() => enhanceChoiceItems());
    });
  });

  document.addEventListener("click", (event) => {
    const listItem = event.target.closest(".wpcf7-list-item");
    if (!listItem || listItem.getAttribute(FOCUSABLE_ATTR) !== "1") return;

    if (event.target.closest("input")) return;

    const isChoiceItem =
      listItem.closest(".wpcf7-checkbox, .wpcf7-radio") !== null;
    if (!isChoiceItem) return;

    const input = listItem.querySelector(
      'input[type="checkbox"], input[type="radio"]',
    );
    if (!input || input.disabled) return;

    input.click();
    listItem.focus({ preventScroll: true });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;

    const listItem = event.target.closest(".wpcf7-list-item");
    if (!listItem || listItem.getAttribute(FOCUSABLE_ATTR) !== "1") return;
    if (!listItem.closest(".wpcf7-checkbox, .wpcf7-radio")) return;

    const input = listItem.querySelector(
      'input[type="checkbox"], input[type="radio"]',
    );
    if (!input || input.disabled) return;

    event.preventDefault();
    input.click();
    listItem.focus({ preventScroll: true });
  });
};
